module.exports = __webpack_public_path__ + "static/media/card-reusable-cup.0ac3cca0.png";